namespace GeniuzPOS.Product {
    export interface CsColorForm {
        ColorId: Serenity.StringEditor;
        ColorName: Serenity.StringEditor;
    }

    export class CsColorForm extends Serenity.PrefixedContext {
        static formKey = 'Product.CsColor';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CsColorForm.init)  {
                CsColorForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(CsColorForm, [
                    'ColorId', w0,
                    'ColorName', w0
                ]);
            }
        }
    }
}
